{
  "name": "Tebis-Process-Solution",
  "version": "dev",
  "message": "... will be patched with commit or tag message by patch-package-json gitlab job",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:coverage:gitlab": "ng test --no-watch --no-progress --coverage --coverage-reporters=cobertura --coverage-reporters=lcov",
    "typedoc": "pnpm exec typedoc",
    "lint": "pnpm exec eslint projects/tebiproc/src",
    "madge": "node madge",
    "check": "pnpm exec eslint projects/tebiproc/src && node madge",
    "e2e:testids:generate": "node projects/tebiproc/e2e/generate-testids.mjs"
  },
  "private": true,
  "packageManager": "pnpm@11.18.0",
  "dependencies": {
    "@angular/animations": "^21.0.0",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.1.3",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.2.1",
    "@angular/forms": "^21.2.18",
    "@angular/material": "^21.0.0",
    "@angular/material-date-fns-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.0.0",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/router": "^21.2.18",
    "@aws-sdk/client-bedrock-runtime": "^3.1087.0",
    "@corporate/blitz3d": "^0.2.9",
    "@corporate/ng-tebis-base-components": "^0.3.11",
    "angular-oauth2-oidc": "^21.0.3",
    "date-fns": "^4.4.0",
    "i18next": "^24.2.3",
    "jwt-decode": "^4.0.0",
    "ngx-doc-viewer": "^21.0.6",
    "rxjs": "~7.8.0",
    "three": "^0.184.0",
    "tslib": "^2.3.0",
    "uuid": "^14.0.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.19",
    "@angular/build": "^21.2.16",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.18",
    "@eslint/js": "^9.39.5",
    "@types/three": "^0.184.1",
    "@vitest/coverage-v8": "^4.1.7",
    "eslint": "^9.39.5",
    "eslint-config-prettier": "^10.1.8",
    "globals": "^17.7.0",
    "jsdom": "^27.4.0",
    "madge": "^8.0.0",
    "tsx": "^4.23.1",
    "typedoc": "^0.28.20",
    "typedoc-plugin-coverage": "^4.0.3",
    "typedoc-plugin-missing-exports": "^4.1.4",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.64.0",
    "vitest": "^4.1.3"
  }
}